<template>
  <date-display
    :value="new Date().toISOString()"
    dateFormat="dddd D MMMM YYYY"
    class="d-none d-lg-block text-muted"
    icon-class=""
    style="font-size: 90%"
  />
</template>

<script>
import { DateDisplay } from '@/components/shared'

export default {
  name: 'Date',
  components: {
    DateDisplay
  }
}
</script>
